import Api from "~/service/Api";

class AwsLambdaUnzipInvocationRepository {
  create(data) {
    return Api.post("/aws-lambda/unzip-invocations", data);
  }
}

export default AwsLambdaUnzipInvocationRepository;
